<template>
  <div class="content">
    <div class="bank-accordion-frame" :class="{ 'active': showAccountQuick }">
      <button class="bank-accordion-btn" @click="showAccountQuick = !showAccountQuick">
        <span class="bank-title">{{ $t('Bao.payment_method') }}</span>
        <span class="selected-channel">{{ selectedTypeName }}</span>
        <span class="accordion-arrow">&#129170;</span>
      </button>

      <div v-for="(type, tkey) in types.filter(t => t.type === 1 )" :key="tkey">
        <div v-for="(item, key) in type.payments" :key="key" class="bank-choice-item" :class="{active: selectedPayment && item.payment_id === selectedPayment.payment_id}" @click="selectPayment(item, type.name, type.code)">
          <i>
            <img :src="item.image" alt="">
          </i>
          <div class="bank-choice-text">
            <span>{{ type.name }}</span>

            <span>{{ $t('Bao.min_to_max') }}:{{ $store.state.brand.currency }}{{ item.amount_limit.min | numberFormat }}-{{ $store.state.brand.currency }}{{ item.amount_limit.max | numberFormat }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bank-account-detail">
      <div class="my-form-input">
        <div class="form-input">
          <label>{{ $t('Bao.deposit_amount') }}</label>
          <template v-if="selectedPayment">
            <ul class="quick-deposit">
              <li
                v-for="(price, key) in selectedPayment.price_list"
                :key="key"
                :class="{ active: price === selectedAmount }"
                @click="handleAmount(price)"
              >
                <button class="btn-default-deposit">
                  <span>+{{ $store.state.brand.currency }}{{ price | numberFormat }}</span>
                </button>
              </li>
            </ul>
          </template>
        </div>
        <div class="form-input">
          <label>{{ $t('Bao.amount') }}</label>
          <input v-model="postForm.amount" type="text" placeholder="" @input="validateNumber" @change="onAmountChange">
          <div v-if="eventBonus===0" class=" d-flex">
            <span class="help-block"> {{ $t("Bao.first_deposit_error") }}</span>
          </div>
        </div>

        <div v-if="selectedTypeCode === 'BankToBank'" class="form-input">
          <label>{{ $t('Bao.card_label') }}</label>
          <input v-model="postForm.userName" type="text" :placeholder="$t('Bao.card_name')">
        </div>
        <!-- <div class="my-form-input deposit-form">
          <div class="form-input subtitle">
            <label class="h5">信用卡資料</label>
          </div>
          <div class="form-input card-name">
            <label>信用卡登記姓名</label>
            <input type="text" placeholder="">
          </div>
          <div class="form-input card-number">
            <label>信用卡卡號</label>
            <input type="text" placeholder="">
          </div>
          <div class="form-input card-day">
            <label>卡片使用期限</label>
            <input type="text" placeholder="">
          </div>
          <div class="form-input card-security">
            <label>安全碼</label>
            <input type="text" placeholder="">
          </div>
        </div> -->
      </div>

      <div class="deposit-detail">
        <ul>
          <li>
            <b>{{ $t('Bao.deposit_amount') }}</b>
            <span>{{ $store.state.brand.currency }} {{ postForm.amount | numberFormat }}</span>
          </li>
          <li>
            <b>{{ $t('Bao.event_bonus') }}</b>
            <span>{{ eventBonus | numberFormat }}</span>
          </li>
          <li>
            <b>{{ $t('Bao.deposit_total_tip') }}</b>
            <span>{{ $store.state.brand.currency }} {{ calculateTotalBonus() | numberFormat }}</span>
          </li>
        </ul>
        <template v-if="selectedPayment">
          <p v-if="selectedPayment.name === 'TigerPay'">
            {{ $t('Bao.payment_ewallet_describe_1') }}
            <br>
            {{ $t('Bao.payment_ewallet_describe_2') }}
          </p>
          <p v-else>
            {{ $t('Bao.payment_bank_describe_1') }}
            <br>
            {{ $t('Bao.payment_bank_describe_2') }}
          </p>
        </template>
      </div>
      <hr>
      <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-style-primary-golden btn-w-xl btn-deposit" :disabled="isButtonDisable" @click="handleSubmit()">
          <span>{{ $t('Bao.deposit') }}</span>
          <span v-show="postForm.amount !== 0">{{ $store.state.brand.currency }}{{ postForm.amount | numberFormat }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { showNotice, setErrorMessage } from '@/utils/tool'
import {
  DepositType,
  DepositPayment,
  DepositSetting
} from '@/api/payment'
import { getEvent, getEventDetail, joinEvent, getEventQualification } from '@/api/event'

export default {
  components: {

  },
  data() {
    const postForm = {
      payment_id: null,
      amount: 0,
      other: null,
      bank_account_id: null,
      deposit_name: null,
      deposit_method: '',
      isButtonDisabled: false,
      userName: '',
      join_event_info: []
    }

    return {
      types: [],
      selectedPayment: null,
      postForm,
      events: [],
      eventBonus: 0,
      selectedEvent: null,
      deposit_v2: null,
      custom_first: null,
      custom_first_id: null,
      selectedAmount: null,
      showAccountQuick: false,
      selectedTypeName: '',
      selectedTypeCode: ''
    }
  },
  computed: {
    isButtonDisable() {
      const num = parseInt(this.postForm.amount, 10)
      return (
        this.postForm.payment_id === null || isNaN(num) || num <= 0 || this.eventBonus === 0
      )
    },
    memberInfo() {
      return this.$store.state.user.memberInfo
    }
  },
  watch: {
    selectedEvent() {
      this.calculateBonus()
    },
    'postForm.amount'() {
      this.calculateBonus()
    }
  },
  async created() {
    try {
    // Load deposit types
      const depositTypeResponse = await DepositType()
      this.types = depositTypeResponse.data.data
      // Load event details
      const eventResponse = await getEvent()
      for (const item of eventResponse.data.data.list) {
        if (item.is_show_in_deposit === 0 && item.type === 'custom_first_deposit') {
          this.events.push(item)
          this.custom_first_id = item.id
        }
      }
      // Load event details for each event
      const eventDetailsPromises = this.events.map(async(event, index) => {
        const detailResponse = await getEventDetail(event.id)
        const eventDetail = detailResponse.data.data
        eventDetail.select = false
        this.events.splice(index, 1, eventDetail)
        return eventDetail
      })
      // Wait for all event details to be loaded
      const loadedEvents = await Promise.all(eventDetailsPromises)
      this.custom_first = loadedEvents

      const currentUrl = window.location.href
      // Extract the prize rate from the URL and assign it
      if (this.custom_first && this.custom_first.length > 0 && this.custom_first[0].setting && this.custom_first[0].setting.length > 0) {
        const urlSegments = currentUrl.split('/')
        const extractedNumber = parseInt(urlSegments[urlSegments.length - 2], 10)
        const extractedTime = parseInt(urlSegments[urlSegments.length - 1], 10)

        this.custom_first[0].setting[0].prize = extractedNumber
        this.custom_first[0].setting[0].time = extractedTime
      }
      // Load deposit setting
      const depositSettingResponse = await DepositSetting()
      this.postForm.amount = parseInt(parseFloat(depositSettingResponse.data.data.info.default_deposit_amount))

      // Make sure custom_first[0] exists before calling getEventQualification
      if (this.custom_first && this.custom_first.length > 0) {
        const response = await getEventQualification(this.custom_first[0].type, this.custom_first[0].setting[0].prize, this.postForm.amount, this.custom_first[0].setting[0].time)
        if (response.data.data.code === 0) {
          console.log('QUALIFY')
        } else {
          const errorMessages = {
            1: 'Bao.special_deposit_err1',
            2: 'Bao.special_deposit_err2',
            3: 'Bao.special_deposit_err3',
            4: 'Bao.special_deposit_err4',
            5: 'Bao.special_deposit_err5',
            6: 'Bao.special_deposit_err6',
            7: 'Bao.special_deposit_err7',
            2101: 'Bao.member_type_not_pass'
          }
          const errorMessage = errorMessages[response.data.data.code]
          if (errorMessage) {
            showNotice(this.$t(errorMessage), () => {
              this.$router.push('/').then(() => {
                window.location.reload()
              }).catch(() => {
              })
            }, true, false, this.$t('Bao.ok_btn'))
          }
        }
      }
    } catch (err) {
      showNotice(err, () => {
        this.$router.push('/')
        setTimeout(() => {
          location.reload()
        }, 1000)
      }, true, false, true)
    }
  },
  beforeDestroy() {
    this.$store.commit('SET_CAMP_DEPOSIT_OPEN', false)
  },
  methods: {
    selectPayment(payment, name, code) {
      this.selectedTypeCode = code
      this.selectedPayment = payment
      this.postForm.payment_id = payment.payment_id
      this.postForm.join_event_info = JSON.stringify([{
        'type': 'custom_first_deposit',
        'prize_rate': this.custom_first[0].setting[0].prize,
        'time': this.custom_first[0].setting[0].time
      }])
      this.selectedTypeName = name
      this.showAccountQuick = false
    },
    validateNumber(event) {
      // 只允許輸入整數
      event.target.value = event.target.value.replace(/[^0-9]/g, '')
      this.postForm.amount = event.target.value
    },
    async onAmountChange() {
      if (this.custom_first && this.custom_first.length > 0 && this.custom_first[0].setting && this.custom_first[0].setting.length > 0) {
        try {
          const response = await getEventQualification(this.custom_first[0].type, this.custom_first[0].setting[0].prize, this.postForm.amount, this.custom_first[0].setting[0].time)
          if (response.data.data.code === 0) {
            console.log('QUALIFY')
          } else {
            const errorMessages = {
              1: 'Bao.special_deposit_err1',
              2: 'Bao.special_deposit_err2',
              3: 'Bao.special_deposit_err3',
              4: 'Bao.special_deposit_err4',
              5: 'Bao.special_deposit_err5',
              6: 'Bao.special_deposit_err6',
              7: 'Bao.special_deposit_err7'
            }
            const errorMessage = errorMessages[response.data.data.code]
            if (errorMessage) {
              showNotice(this.$t(errorMessage), () => {
                this.$router.push('/').then(() => {
                  window.location.reload()
                }).catch(() => {
                })
              }, true, false, this.$t('Bao.ok_btn'))
            }
          }
        } catch (err) {
          showNotice(err, () => {
            this.$router.push('/')
            setTimeout(() => {
              location.reload()
            }, 1000)
          })
        }
      }
    },
    handleAmount(amount) {
      this.postForm.amount = amount
      this.selectedAmount = amount
    },
    calculateBonus() {
      if (this.postForm.amount === '' || isNaN(this.postForm.amount)) return

      const amount = parseInt(this.postForm.amount)
      if (this.selectedEvent === null) {
        // 註冊後多久首存（秒）- condition_value
        // 首存最低金額 - condition_value_2
        // 獎金比例設置（％） - prize
        // 獎金金額上線 - upper_limit
        // 獎金流水倍數 - performance
        if (this.custom_first) {
          const custom_deposit = this.custom_first[0].setting[0]

          if (amount < custom_deposit.condition_value_2) {
            this.eventBonus = 0
          } else if (custom_deposit.upper_limit >= amount * (custom_deposit.prize / 100)) {
            const prize = amount * (custom_deposit.prize / 100)
            this.eventBonus = parseFloat(prize)
          } else if (custom_deposit.upper_limit <= amount * (custom_deposit.prize / 100)) {
            const prize = custom_deposit.upper_limit
            this.eventBonus = parseFloat(prize)
          }
        }
      }
    },
    calculateTotalBonus() {
      if (this.postForm.amount === '') {
        return this.eventBonus
      } else {
        return parseInt(this.postForm.amount) + this.eventBonus
      }
    },
    handleSubmit() {
      const self = this
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          if (this.selectedPayment.id === 'manual') {
            console.log('manual')
          } else {
            if (this.selectedEvent) {
              joinEvent(this.selectedEvent.id)
                .then(() => {})
                .catch((error) => {
                  showNotice(error.response.data.msg)
                })
            }
          }
        }
      })
      if (!this.$store.getters.deviceInfo.is_webview) {
        var newWindow = window.open('/loading.html', '_blank')
      }
      // This ensures DepositPayment is always triggered, regardless of validation result
      DepositPayment(this.postForm)
        .then((response) => {
          const result = response.data.data

          this.url = result.content
          if (newWindow !== undefined) {
            newWindow.location = this.url

            showNotice(
              this.$t('Bao.deposit_processing_notice_1'),
              () => {
                this.$store.commit('SET_CAMP_DEPOSIT_OPEN', false)
                this.$router.push({ path: '/user/deposit-record' }).then(() => {
                  window.location.reload()
                }).catch(() => {
                })
              }
            )
            // 偵測新視窗是否關閉
            var startCheck = false
            self.listenTimer = window.setInterval(function() {
              try {
                var newHost = newWindow.location.host
              } catch (e) {
                newHost = 'cross domain'
              }

              console.log('detect..', newHost, startCheck)
              if (newHost !== window.location.host) {
                startCheck = true
              }

              if (newHost === window.location.host && startCheck) {
                newWindow.close()
                window.clearInterval(self.listenTimer)
                showNotice('closeModal')
                self.$router
                  .push({ path: '/user/deposit-record' }).then(() => {
                    window.location.reload()
                  }).catch(() => {
                  })
              } else if (newWindow.closed) {
                window.clearInterval(self.listenTimer)
                showNotice('closeModal')
                self.$router
                  .push({ path: '/user/deposit-record' }).then(() => {
                    window.location.reload()
                  }).catch(() => {
                  })
              }
            }, 1000)
          } else {
            // app不另開視窗
            window.location = this.url
          }
        })
        .catch((error) => {
          setErrorMessage(error.response, this.errors)

          if (newWindow !== undefined) {
            newWindow.close()
          }
        })
    }
  }
}
</script>

<style>

</style>
